import Galka from "~assets/img/fe_check.png";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

import s from "./popover.less";

export default function Popover(props) {
  const {
    trigger,
    content,
    direction,
    children,
    menuTitle = "Изменить статус:",
    showSelected = true,
    menuWidth = 200,
    matchTriggerWidth = false,
    iconPosition = "right",
    portalClassName = "",
  } = props;

  const [hidden, setHidden] = useState(true);
  const rootRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const [openedWidth, setOpenedWidth] = useState(menuWidth);

  const calcCoords = useCallback(() => {
    if (!rootRef.current) return;
    const rect = rootRef.current.getBoundingClientRect();
    const POPOVER_WIDTH = matchTriggerWidth ? rect.width : menuWidth;
    setOpenedWidth(POPOVER_WIDTH);
    const POPOVER_HEIGHT = 120;

    let top: number;
    let left: number;

    // Автопереключение направления при выходе за границы viewport
    let calcDirection = direction ?? "bottom";

    // Проверка: выбранное направление + противоположное по той же оси помещаются в viewport?
    const fitsRight = rect.right + POPOVER_WIDTH <= window.innerWidth;
    const fitsLeft = rect.left - POPOVER_WIDTH >= 0;
    const fitsTop = rect.top - POPOVER_HEIGHT >= 0;
    const fitsBottom = rect.bottom + POPOVER_HEIGHT <= window.innerHeight;

    // Если предпочтительное направление не помещается — пробуем противоположное
    if (calcDirection === "right" && !fitsRight && fitsLeft) {
      calcDirection = "left";
    } else if (calcDirection === "left" && !fitsLeft && fitsRight) {
      calcDirection = "right";
    } else if (calcDirection === "top" && !fitsTop && fitsBottom) {
      calcDirection = "bottom";
    } else if (calcDirection === "bottom" && !fitsBottom && fitsTop) {
      calcDirection = "top";
    }

    switch (calcDirection) {
      case "left":
        top = rect.top;
        left = rect.left - POPOVER_WIDTH;
        break;
      case "right":
        top = rect.top;
        left = rect.right;
        break;
      case "top":
        top = rect.top - POPOVER_HEIGHT;
        left = rect.left;
        break;
      case "bottom":
      default:
        top = rect.bottom;
        left = rect.left;
        break;
    }

    setCoords({ top, left });
  }, [direction, menuWidth, matchTriggerWidth]);

  function handleClick() {
    calcCoords();
    setHidden((prev) => !prev);
  }

  useEffect(() => {
    if (hidden || trigger !== "click") return;

    const onPointerDownCapture = (e: PointerEvent) => {
      const target = e.target as Node;
      if (
        rootRef.current?.contains(target) ||
        menuRef.current?.contains(target)
      ) {
        return;
      }
      setHidden(true);
      e.preventDefault();
      e.stopPropagation();
    };

    const onScroll = () => setHidden(true);

    document.addEventListener("pointerdown", onPointerDownCapture, true);
    document.addEventListener("scroll", onScroll, true);

    return () => {
      document.removeEventListener("pointerdown", onPointerDownCapture, true);
      document.removeEventListener("scroll", onScroll, true);
    };
  }, [hidden, trigger]);

  return (
    <div
      ref={rootRef}
      className={`${s.info} ${
        !hidden && trigger === "click" ? s.infoOpen : ""
      }`}
      {...(trigger === "click" && { onClick: handleClick })}
    >
      {children}
      {!hidden &&
        trigger === "click" &&
        ReactDOM.createPortal(
          <div
            ref={menuRef}
            className={`${s.popoverPortal} ${
              iconPosition === "left" ? s.popoverPortalLeadIcon : ""
            } ${portalClassName}`.trim()}
            style={{ top: coords.top, left: coords.left, width: openedWidth }}
          >
            {menuTitle ? <div className={s.title}>{menuTitle}</div> : null}
            <div className={s.status}>
              {content.map((status, index) => {
                const isSelected =
                  showSelected && props.selectedValue === status.value;
                const trailing =
                  iconPosition === "right" ? (
                    isSelected ? (
                      <img src={Galka} alt="Galka" />
                    ) : (
                      (status.icon ?? null)
                    )
                  ) : isSelected ? (
                    <img src={Galka} alt="Galka" />
                  ) : null;

                return (
                  <div
                    key={index}
                    className={s.statusList}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!isSelected) {
                        props.onSelect?.(status);
                        setHidden(true);
                      }
                    }}
                  >
                    {iconPosition === "left" && status.icon ? (
                      <div className={s.statusListLeadIcon}>{status.icon}</div>
                    ) : null}
                    <div className={s.statusListLabel}>{status.label}</div>
                    {trailing ? (
                      <div className={s.statusListIcon}>{trailing}</div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
}
